export function numberMin() {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.min = function (modelValue, viewValue) {

                return (parseFloat(modelValue) >= attrs.numberMin | !modelValue);
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/ui/directives/number-min.directive.js